import { useContext, useState } from "react";
import { Box, Typography, Divider, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import BorderLinearProgress from "@mui/material/LinearProgress";
import { colors } from "../../style/color/colors";
import { String } from "../../constants/Strings";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const ChildGoalComponent = ({ child }) => {
  const [expanded, setExpanded] = useState(false);

  const currentValue = Number(child.currentValueAmount);
  const targetAmount = Number(child.targetValueAmount);

  let currentPercentage;
  if (targetAmount > 0) {
    currentPercentage = (currentValue / targetAmount) * 100; 
  }
  if (targetAmount < currentValue) {
    currentPercentage = 100;
  }

  const { verifyData } = useContext(OTPVerifyContext);

  const toggleExpand = () => {
    gaCustomEvent(
      String.gaEventName.acrDashboard,
      String.gaEventClickName.acrDashboardChildEducationView,
      verifyData.customerId,
    );
    gaCustomEvent(
      String.gaEventName.acrDashboard,
      String.gaEventClickName.acrDashboardChildMarriageView,
      verifyData.customerId,
    );

    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{ mt: "10px", border: "0.60px #A8ABB1 solid", borderRadius: 5, p: 1 }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "space-between" }}
        component={"div"}
        onClick={toggleExpand}
      >
        <Typography
          sx={{
            color: colors.NeutralDark700,
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {child.name}
        </Typography>
        <IconButton onClick={toggleExpand} sx={{ p: 0 }}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      {expanded && (
        <Box sx={{}}>
          <Typography
            sx={{
              color: colors.NeutralsMidN300,
              fontSize: 12,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {`Age: ${child.age}`}
          </Typography>
          <Divider variant="fullWidth" sx={{ mt: "10px" }} />
          <Box sx={{ p: 1 }}>
            <Box sx={{ width: "100%", mt: 2, borderRadius: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>
                  ₹
                  {currentValue.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </Typography>
                <Typography>
                  ₹
                  {targetAmount.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </Typography>
              </Box>
              <BorderLinearProgress
                variant="determinate"
                value={currentPercentage}
                sx={{
                  borderRadius: 10,
                  height: "7px",
                  backgroundColor: "white",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: colors.ColorSurfacebgboldIrishGreen,
                  },
                }}
              />
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography
                sx={{
                  color: colors.NeutralsMidN300,
                  fontSize: 10,
                  fontFamily: fonts.manrope,
                  fontWeight: "700",
                }}
              >
                {String.Dashboard.currentandtarget.CurrentValue}
              </Typography>
              <Typography
                sx={{
                  color: colors.NeutralsMidN300,
                  fontSize: 10,
                  fontFamily: fonts.manrope,
                  fontWeight: "700",
                }}
              >
                {String.Dashboard.currentandtarget.TargetAmount}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ChildGoalComponent;
